import { FlowBaseInfo } from '../../ts/models/FlowInfo';
import { Set } from '../../ts/models/Set';
import { Messages, Formatters } from '../../codegen/Localize';
import { L10n } from '../../ts/L10n/L10n';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { Flows } from '../../ts/resources/Flows';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ActionHelpers, standardActionSuccessMsg, standardActionErrorMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { FlowErrors } from '../services/FlowErrors';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';

export function showRunFlowDialog(flows: Set<FlowBaseInfo>, isRunAllIncremental: boolean = null): Promise<IResult> {
  let message: string;

  if (flows.size() === 1) {
    const flow = flows.first();
    message = Messages.runFlowsSinglePrompt({ FLOW_NAME: L10n.elideIfLong(flow.name) });
  } else {
    message = Messages.runFlowsMultiplePrompt({ ITEM_COUNT_LOC: Formatters.formatCount(flows.size()) });
  }

  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.runNow(),
    message: message,
    paramsForAction: undefined,
    actionName: Messages.runNow(),
    action: () => Flows.runFlow(flows.keys(), isRunAllIncremental),
    dialogWidth: TabDialogWidth.width375px,
  });

  dialogInstance.result.then((result: IResult) => {
    ActionHelpers.displayStandardToastsForResult(
      flows,
      result,
      {
        success: standardActionSuccessMsg(Messages.runFlowsSuccess),
        error: standardActionErrorMsg(Messages.runFlowsError),
      },
      (errorItem: IErrorItem<FlowBaseInfo>) => FlowErrors.errorDetailsFor(errorItem)
    );
  });

  return Promise.resolve(dialogInstance.result);
}
